/**
 * @desc 全量权限ID（除叶子节点）
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPermissionIdResponse>> {
  return defHttp.get({
    url: '/web/rolePermission/selectId',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPermissionIdResponse>> {
  return defHttp.get({
    url: '/mock/web/rolePermission/selectId',
  });
}
